module.exports = __webpack_public_path__ + "static/img/renwutongbu.2a6ab80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/renwutongbu.png
// module id = uHUr
// module chunks = 24